export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      backgroundColor: theme.palette.red.main,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundColor: theme.palette.red.main,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  content: {
    position: 'relative',
    zIndex: 5,
    width: '100%',
    height: '100%',
  },
  main: {
    display: 'flex',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  desc: {
    flex: '6 1 0',
    padding: theme.spacing(12),
    color: theme.palette.secondary.main,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      display: 'block',
      '& h6': {
        paddingBottom: theme.spacing(2),
      },
    },
  },
  text: {
    display: 'flex',
    '& > *': {
      width: '100%',
    },
    '& > *:first-child': {
      paddingRight: theme.spacing(4),
    },
    '& > *:last-child': {
      paddingLeft: theme.spacing(4),
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
      '& > *:first-child': {
        paddingRight: 'initial',
      },
      '& > *:last-child': {
        paddingLeft: 'initial',
      },
    },
  },
  itvBtn: {
    marginTop: theme.spacing(16),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(8),
    },
  },
  aside: {
    flex: '4 1 0',
    backgroundColor: theme.palette.grey.light,
  },
  asideText: {
    padding: theme.spacing(6),
    height: '70vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      height: 'initial',
      alignItems: 'flex-start',
    },
  },
  article: {
    marginBottom: theme.spacing(4),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  image: {
    width: '100%',
    height: '30vh',
    '& > img': {
      maxWidth: '100%',
      maxHeight: '100%',
      width: '100%',
      objectFit: 'cover',
    },
  },
});
